var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonBruteForce = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.054 15.022L24.8 11.94a2.46 2.46 0 00-.8-.128c-.269-.002-.54.04-.8.128l-9.253 3.082a2.782 2.782 0 00-1.902 2.64v9.766l.012.036c.182 2.621 6.99 9.056 11.896 10.805h.096c4.905-1.749 11.715-8.184 11.895-10.805l.011-.036v-9.767a2.78 2.78 0 00-1.9-2.64z", fill: fills.dark }),
        React.createElement("path", { d: "M38.901 40.774l-1.305 1.305c-.605.605-1.64.176-1.64-.68v-4.358c0-.53.43-.96.96-.96h4.358c.856 0 1.285 1.035.68 1.64l-1.149 1.149 2.8 2.921a1.347 1.347 0 01-1.903 1.904l-2.8-2.921z", fill: fills.base }),
        React.createElement("path", { d: "M38.946 7.316L37.641 6.01c-.605-.605-1.64-.176-1.64.68v4.358c0 .531.43.96.96.96h4.358c.856 0 1.285-1.035.68-1.64L40.85 9.22l2.8-2.922a1.346 1.346 0 00-1.904-1.904l-2.8 2.922zM9.054 40.774l1.305 1.305c.605.605 1.641.176 1.641-.68v-4.358a.96.96 0 00-.96-.96H6.68c-.856 0-1.285 1.035-.68 1.64L7.15 38.87l-2.8 2.921a1.347 1.347 0 001.904 1.904l2.8-2.921z", fill: fills.light }),
        React.createElement("path", { d: "M9.054 7.307L10.359 6c.605-.605 1.641-.176 1.641.68v4.358c0 .531-.43.961-.96.961H6.68c-.856 0-1.285-1.036-.68-1.64L7.15 9.21l-2.8-2.92a1.347 1.347 0 011.904-1.905l2.8 2.922z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
